import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';

interface RowData {
  stage: string;
  energy_output?: number | string;
  energy_loss?: number | string;
  energy_loss_gas?: number | string;
  energy_loss_ch4?: number | string;
  energy_input?: number | string;
}

interface EnergyTableProps {
  title: string;
  rows: RowData[];
}

export const EnergyTable: React.FC<EnergyTableProps> = ({ title, rows }) => {
  const columns = [
    { key: 'energy_output', label: 'Energy output from stage' },
    { key: 'energy_loss', label: 'Energy loss from co-products from stage' },
    {
      key: 'energy_loss_gas',
      label: 'Energy loss from gas consumption from stage',
    },
    {
      key: 'energy_loss_ch4',
      label: 'Energy loss from CH4 emission from stage',
    },
    { key: 'energy_input', label: 'Energy input into stage' },
  ];

  return (
    <TableContainer
      component={Paper}
      sx={{ marginBottom: 4 }}
      className={'table-container'}
    >
      <Typography variant="h6" sx={{ padding: 2 }}>
        {title}
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center" sx={{ fontWeight: 'bold' }}>
              Stage
            </TableCell>
            {columns.map((col, index) => (
              <TableCell key={index} align="center" sx={{ fontWeight: 'bold' }}>
                {col.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                {row.stage}
              </TableCell>
              {columns.map((col, colIndex) => (
                <TableCell key={colIndex} align="center">
                  {row[col.key as keyof RowData] !== undefined
                    ? row[col.key as keyof RowData]
                    : '-'}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
